import SectionBody from '../components/SectionBody';
import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

export default function Us() {
  return (
    <SectionContainer containerId={'us'}>
      <SectionTitle title={'loren + robbie'} />
      <SectionBody>
        <p className='section-text'>
          In 2011, Loren was in the fifth grade at Southport Central School.
          Robbie's family was normally in Southport for the summers, but that
          year they decided to live in Southport for the whole school year.
          Robbie attended school that year as well in the sixth grade, and the
          school was small, so grades 5 and 6 shared a classroom. They quickly
          became friends, developed crushes on one another, and kept in touch
          for several years until late middle school.
        </p>

        <p className='section-text'>
          Years later, Robbie contacted Loren to let her know that his family
          was moving back to Maine and that he would be attending college in
          Boston, MA. She had just moved away to Bar Harbor, so they just missed
          one another. Despite that, they kept in contact. They met in person to
          catch up, and over Loren's senior year of high school they kept in
          contact while Robbie began college. He attended her high school
          graduation, they began dating that summer, and the rest is history.
        </p>
      </SectionBody>
    </SectionContainer>
  );
}
